
        module.exports = __webpack_public_path__ + "assets/images/eco.cf947554.png";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 118,
            height: 96,
            type: "png",
            bytes: 5006,

            toString: function() {
                return src;
            }
        };
    